import { RegionProductPageCriteria } from '../model/region-product-page-criteria';

export namespace RegionActions {
  const prefix = '[Region actions]';

  export class GetPage {
    static readonly type = `${prefix} Get page`;

    constructor(
      readonly distributorId: number,
      readonly criteria: RegionProductPageCriteria
    ) {}
  }

  export class RefreshPage {
    static readonly type = `${prefix} Refresh page`;
  }

  export class ResetState {
    static readonly type = `${prefix} Reset state`;
  }
}
